// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableContainerMigrate {
  max-height: 610px;
  width: 92%;
  margin: 0 5%;
  margin-left: 3.4%;
  margin-top: 20px;
}

.migrateTable {
  max-height: 565px;
  width: auto;
  overflow-y: auto;
  display: block;
  border-spacing: 0px;
}

.migrateTable tbody tr:hover {
  background-color: #cae0ee;
}

.migrateTable tbody tr:active {
  background-color: #71b9e9 !important;
}
.migrateTable tbody tr:visited {
  background-color: #71b9e9 !important;
}

.migrateTable tbody tr td {
  text-align: center;
  padding: 10px;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  cursor: pointer;
  border-bottom: 2px solid #e5e5e5 !important;
}
/* .migrateTable tbody tr:nth-child(even){
 background-color: #E5E5E5;
} */

.migrateTable thead tr th {
  text-align: center;
  position: sticky !important;
  top: 0;
  background-color: #e5e5e5;
  color: #797979;
  padding: 15px 2px;
  width: 102px;
}

.migrateTable thead tr th:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  width: 60px;
  position: sticky;
}

.migrateTable thead tr th:last-child {
  /* border-top-right-radius: 8px;
  border-bottom-right-radius: 8px; */
  width: 225px;
  position: sticky;
}
.child2Migrate {
  width: 108px;
}

.child3Migrate {
  width: 80px;
}

.backlogImageContainer {
  height: 200px;
  display: flex;
  margin: 0 5%;
  justify-content: center;
}

.backlogImage {
  margin-right: 5%;
  width: 200px;
  height: 200px;
  border-radius: 10px;
}

.reactLoadingIconMigrate {
  height: 25px !important;
  margin: auto;
  width: 30px !important;
}

.loadingDivMigrate {
  display: flex;
  margin-left: 12%;
  margin-top: 8%;
  height: 30px;
  width: 290px;
  position: absolute;
}

.migrateImageContainer {
  height: 550px;
  display: flex;
  margin: 0 10%;
  justify-content: center;
}

.migrateBigImage {
  width: 100% !important;
  height: 500px !important;
  border-radius: 10px;
  margin-top: 45px;
}

.migrateAddContainer {
  height: 90px;
  display: flex;
  margin: 0 5%;
  justify-content: center;
}

.migrateButton {
  max-height: 35px;
  margin-top: 45px;
  color: #f2f2f2;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  padding: 8px 15px;
  background: #68dff0;
  cursor: pointer;
}
.migrateButton:hover {
  background-color: #51cac2;
}
.migrateButton:active {
  border: 1px solid #03afa9 !important;
}

.migrateLoading {
  max-height: 35px;
  margin-top: 44px;
}

.loadingTextMigrate {
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 4%;
  margin-left: 5px;
}

.loadingTextData {
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 4%;
  width: 180px;
  margin-left: 15px;
}

.selectDiv {
  display: flex;
}

.selectAllDiv {
  display: flex;
  margin-left: 11%;
  margin-right: 2%;
  height: 24px;
  width: 92px;
  max-height: 35px;
  color: #f2f2f2;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  padding: 6px 5px;
  background: #68dff0;
}

.selectAllInput {
  margin-left: 7%;
  margin-top: 5px;
}

.selectAllP {
  margin: 2px;
  margin-top: 4px;
}

.selectedP {
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 16px;
  margin-bottom: 0px;
  margin-top: 8px;
}

.errorP {
  font-family: "Ruda", sans-serif;
  font-size: 16px;
  margin-bottom: 0px;
  margin-top: 8px;
  color: red;
}

.loadingDivMigrateAdd {
  display: inline-flex;
  height: 30px;
  width: 290px;
  position: absolute;
  margin-top: 1px;
}

.cancelMigrate {
  color: #fff;
  background-color: #68dff0;
  padding: 4px 12px;
  margin-bottom: 0px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 5px;
  height: 34px;
  border: none;
}
.cancelMigrate:hover {
  background-color: #51cac2;
}
.cancelMigrate:active {
  border: 1px solid #03afa9 !important;
}

.reactLoadingIconAdd {
  height: 25px !important;
  margin-left: 10px;
  width: 30px !important;
  margin-right: 18px;
  margin-top: 5px;
}

.loadingTextAdd {
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 0;
  font-weight: 500;
  margin-right: 4%;
  width: 180px;
}

.loadingTextMigrateError {
  color: red;
  font-family: "Ruda", sans-serif;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 4%;
  margin-left: 5px;
}

.checkboxhid {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Screens/Migrate/migrate.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,2CAA2C;AAC7C;AACA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,MAAM;EACN,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;oCACkC;EAClC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".tableContainerMigrate {\n  max-height: 610px;\n  width: 92%;\n  margin: 0 5%;\n  margin-left: 3.4%;\n  margin-top: 20px;\n}\n\n.migrateTable {\n  max-height: 565px;\n  width: auto;\n  overflow-y: auto;\n  display: block;\n  border-spacing: 0px;\n}\n\n.migrateTable tbody tr:hover {\n  background-color: #cae0ee;\n}\n\n.migrateTable tbody tr:active {\n  background-color: #71b9e9 !important;\n}\n.migrateTable tbody tr:visited {\n  background-color: #71b9e9 !important;\n}\n\n.migrateTable tbody tr td {\n  text-align: center;\n  padding: 10px;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  cursor: pointer;\n  border-bottom: 2px solid #e5e5e5 !important;\n}\n/* .migrateTable tbody tr:nth-child(even){\n background-color: #E5E5E5;\n} */\n\n.migrateTable thead tr th {\n  text-align: center;\n  position: sticky !important;\n  top: 0;\n  background-color: #e5e5e5;\n  color: #797979;\n  padding: 15px 2px;\n  width: 102px;\n}\n\n.migrateTable thead tr th:first-child {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  width: 60px;\n  position: sticky;\n}\n\n.migrateTable thead tr th:last-child {\n  /* border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px; */\n  width: 225px;\n  position: sticky;\n}\n.child2Migrate {\n  width: 108px;\n}\n\n.child3Migrate {\n  width: 80px;\n}\n\n.backlogImageContainer {\n  height: 200px;\n  display: flex;\n  margin: 0 5%;\n  justify-content: center;\n}\n\n.backlogImage {\n  margin-right: 5%;\n  width: 200px;\n  height: 200px;\n  border-radius: 10px;\n}\n\n.reactLoadingIconMigrate {\n  height: 25px !important;\n  margin: auto;\n  width: 30px !important;\n}\n\n.loadingDivMigrate {\n  display: flex;\n  margin-left: 12%;\n  margin-top: 8%;\n  height: 30px;\n  width: 290px;\n  position: absolute;\n}\n\n.migrateImageContainer {\n  height: 550px;\n  display: flex;\n  margin: 0 10%;\n  justify-content: center;\n}\n\n.migrateBigImage {\n  width: 100% !important;\n  height: 500px !important;\n  border-radius: 10px;\n  margin-top: 45px;\n}\n\n.migrateAddContainer {\n  height: 90px;\n  display: flex;\n  margin: 0 5%;\n  justify-content: center;\n}\n\n.migrateButton {\n  max-height: 35px;\n  margin-top: 45px;\n  color: #f2f2f2;\n  font-size: 14px;\n  border-radius: 4px;\n  border: none;\n  padding: 8px 15px;\n  background: #68dff0;\n  cursor: pointer;\n}\n.migrateButton:hover {\n  background-color: #51cac2;\n}\n.migrateButton:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.migrateLoading {\n  max-height: 35px;\n  margin-top: 44px;\n}\n\n.loadingTextMigrate {\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 4%;\n  margin-left: 5px;\n}\n\n.loadingTextData {\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 4%;\n  width: 180px;\n  margin-left: 15px;\n}\n\n.selectDiv {\n  display: flex;\n}\n\n.selectAllDiv {\n  display: flex;\n  margin-left: 11%;\n  margin-right: 2%;\n  height: 24px;\n  width: 92px;\n  max-height: 35px;\n  color: #f2f2f2;\n  font-size: 14px;\n  border-radius: 4px;\n  border: none;\n  padding: 6px 5px;\n  background: #68dff0;\n}\n\n.selectAllInput {\n  margin-left: 7%;\n  margin-top: 5px;\n}\n\n.selectAllP {\n  margin: 2px;\n  margin-top: 4px;\n}\n\n.selectedP {\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 16px;\n  margin-bottom: 0px;\n  margin-top: 8px;\n}\n\n.errorP {\n  font-family: \"Ruda\", sans-serif;\n  font-size: 16px;\n  margin-bottom: 0px;\n  margin-top: 8px;\n  color: red;\n}\n\n.loadingDivMigrateAdd {\n  display: inline-flex;\n  height: 30px;\n  width: 290px;\n  position: absolute;\n  margin-top: 1px;\n}\n\n.cancelMigrate {\n  color: #fff;\n  background-color: #68dff0;\n  padding: 4px 12px;\n  margin-bottom: 0px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: 10px;\n  margin-right: 5px;\n  height: 34px;\n  border: none;\n}\n.cancelMigrate:hover {\n  background-color: #51cac2;\n}\n.cancelMigrate:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.reactLoadingIconAdd {\n  height: 25px !important;\n  margin-left: 10px;\n  width: 30px !important;\n  margin-right: 18px;\n  margin-top: 5px;\n}\n\n.loadingTextAdd {\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 0;\n  font-weight: 500;\n  margin-right: 4%;\n  width: 180px;\n}\n\n.loadingTextMigrateError {\n  color: red;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 4%;\n  margin-left: 5px;\n}\n\n.checkboxhid {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
